export default __webpack_public_path__ + "static/media/179.d7bbd77c.jpg";